import * as React from "react"
import { Tooltip as DefaultTooltip, TooltipProps } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { blendWithWhiteBackground } from "../../../util";

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  ...otherProps
}) => {
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <DefaultTooltip
      {...otherProps}
      background={blendWithWhiteBackground(roomStyles?.servicePanelElementModalBackground)}
      color={roomStyles.servicePanelElementPrimaryText}
      boxShadow={`0 0 15px ${
        roomStyles?.servicePanelElementBorder ?? "#e2e8f0"
      }`}
    >
      {children}
    </DefaultTooltip>
  )
}
